import { render, staticRenderFns } from "./TaskGoals.vue?vue&type=template&id=f58d046c&"
import script from "./TaskGoals.vue?vue&type=script&lang=js&"
export * from "./TaskGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports